<template>
  <div class="view home">
    <component
      v-for="(c, i) in $store.state.content[$store.state.mode]"
      :key="i"
      :is="c.component"
      :data="c"
      :direction="c.direction || ''"
      :orientation="c.orientation || ''"
      :mode="c.mode || ''"
      :type="c.type || ''"
      :hasDisclaimer="c.hasDisclaimer || false"
    />
    <FooterBlock />
  </div>
</template>

<script>
import TitleBlock from '@/components/TitleBlock.vue';
import ImageBlock from '@/components/ImageBlock.vue';
import TextBlock from '@/components/TextBlock.vue';
import MarqueeBlock from '@/components/MarqueeBlock.vue';
import ImagesBlock from '@/components/ImagesBlock.vue';
import VideoBlock from '@/components/VideoBlock.vue';
import FooterBlock from '@/components/FooterBlock.vue';

export default {
  name: 'Home',

  components: {
    TitleBlock,
    ImageBlock,
    TextBlock,
    MarqueeBlock,
    ImagesBlock,
    VideoBlock,
    FooterBlock,
  },
};
</script>

<style lang="scss">
.view {
  padding-top: 150px;

  @include mq($until: ipadL) {
    padding-top: 100px;
  }
}
</style>
